// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__18gRl","label":"SetPasswdForm_label__Nfodq"};